import { PlatformEnvDataProvider } from '@wix/thunderbolt-symbols'

export function getPlatformEnvData(platformEnvDataProviders: Array<PlatformEnvDataProvider>) {
	return Object.assign({}, ...platformEnvDataProviders.map((envApiProvider) => envApiProvider.platformEnvData))
}
